"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var threshold_exports = {};
__export(threshold_exports, {
  thresholdAttr: () => thresholdAttr,
  thresholdBucket: () => thresholdBucket
});
module.exports = __toCommonJS(threshold_exports);
var import_lodash = require("lodash");
var import_bucket = require("../bucket/index.js");
var import_marker = require("../marker/index.js");
var import_helpers = require("./helpers.js");
function thresholdBucket(value, marker2, label) {
  return { value, marker: marker2, label };
}
function thresholdAttr(props) {
  const {
    attributeId,
    label,
    propertyName = attributeId,
    decimalPlaces,
    format = (0, import_helpers.numberFormatter)(decimalPlaces),
    unit,
    buckets,
    showDistribution = true,
    showTimeline = true
  } = props;
  function convertBuckets(thresholds) {
    if (thresholds.length === 0) {
      return [(0, import_bucket.rangeBucket)(null, null, import_marker.marker.standard, void 0, false)];
    } else {
      const pairs = (0, import_lodash.zip)(thresholds, (0, import_lodash.tail)(thresholds).concat([null]));
      return pairs.map(
        ([prev, next]) => (0, import_bucket.rangeBucket)(prev?.value ?? null, next?.value ?? null, prev?.marker ?? import_marker.marker.standard, prev?.label, false)
      );
    }
  }
  return {
    type: "NumberAttribute",
    attributeId,
    label,
    propertyName,
    format,
    unit,
    buckets: (0, import_bucket.standardBuckets)(convertBuckets(buckets)),
    showDistribution,
    showTimeline
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  thresholdAttr,
  thresholdBucket
});
//# sourceMappingURL=threshold.js.map
